export function setLocalStorage(key, data) {
    if (!window.localStorage) {
        return '';
    }

    window.localStorage.setItem(key, JSON.stringify(data));
}

export function getLocalStorage(key) {
    if (!window.localStorage) {
        return;
    }
    let data = window.localStorage.getItem(key);
    try {
        if (data) {
            return JSON.parse(data);
        } 
    } catch {
        return data;
    }

}

export function removeLocalStorage(key) {
    if (!window.localStorage) {
        return;
    }

    try {
        window.localStorage.removeItem(key);
    } catch (e) {
    }
}

export function clearLocalStorage() {
    if (!window.localStorage) {
        return;
    }

    window.localStorage.clear();
}

// 优化不固定的字段，只保存最新的值
export function delLSContaining(substring) {
    Object.keys(localStorage)
        ?.filter(key => key.includes(substring))
        ?.forEach(key => {
            localStorage.removeItem(key);
        });
}